

import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { environment } from '../../environments/environment';

@Injectable()
export class ItemModifierService {

  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}


  addItemToCart(item: any) {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
        key: "x-api-key",
        value: "NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x",
      }),
    };


          return this.http.post(
          ""+this.apiUrl+"/Bill/AddOrderItem",
          JSON.stringify(item),
          httpOptions
          );

  
      //  return this.http.post(
      //  "http://localhost:57597/api/Bill/AddOrderItem",
      //  JSON.stringify(item),
      //  httpOptions
      //  );
    

  }

  getCartItems(id: any) {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
        key: "x-api-key",
        value: "NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x",
      }),
    };

        return this.http.get(
        ""+this.apiUrl+"/Bill/GetAllOrderItem?OrderMaster_Id=" +
        parseInt(id) +
        "&Fetch=ADD TO CART",
        httpOptions
        );


          //  return this.http.get(
          // "http://localhost:57597/api/Bill/GetAllOrderItem?OrderMaster_Id=" +
          // parseInt(id) +
          // "&Fetch=ADD TO CART",
          // httpOptions
          // );


  }



  addItemToWishlist(item: any) {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
        key: "x-api-key",
        value: "NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x",
      }),
    };

      return this.http.post(
      ""+this.apiUrl+"/Bill/AddOrderItem",
      JSON.stringify(item),
      httpOptions
      );


        // return this.http.post(
        // "http://localhost:57597/api/Bill/AddOrderItem",
        // JSON.stringify(item),
        // httpOptions
        // );



  }

  getWishListtItems(id: any) {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
        key: "x-api-key",
        value: "NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x",
      }),
    };

    return this.http.get(
      ""+this.apiUrl+"/Bill/GetAllOrderItem?OrderMaster_Id=" +
        parseInt(id) +
        "&Fetch=WISH LIST",
      httpOptions
    );


    // return this.http.get(
    //     "http://localhost:57597/api/Bill/GetAllOrderItem?OrderMaster_Id=" +
    //     parseInt(id) +
    //     "&Fetch=WISH LIST",
    //     httpOptions
    // );



  }




  getCartItemsOrdered(id: any) {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
        key: "x-api-key",
        value: "NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x",
      }),
    };


    return this.http.get(
      ""+this.apiUrl+"/Bill/GetAllOrderItem?OrderMaster_Id=" +
        parseInt(id) +
        "&Fetch=ORDER PLACED",
      httpOptions
    );


      // return this.http.get(
      // "http://localhost:57597/api/Bill/GetAllOrderItem?OrderMaster_Id=" +
      // parseInt(id) +
      // "&Fetch=ORDER PLACED",
      // httpOptions
      // );


  }

  getCartItemsOrderedCancelled(id: any) {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
        key: "x-api-key",
        value: "NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x",
      }),
    };


    return this.http.get(
    ""+this.apiUrl+"/Bill/GetAllOrderItem?OrderMaster_Id=" +
        parseInt(id) +
        "&Fetch=ORDER CANCELLED",
      httpOptions
    );


    // return this.http.get(
    //   "http://localhost:57597/api/Bill/GetAllOrderItem?OrderMaster_Id=" +
    //       parseInt(id) +
    //       "&Fetch=ORDER CANCELLED",
    //     httpOptions
    //   );



  }


  getCartItemsOrderedAmt(id: any) {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
        key: "x-api-key",
        value: "NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x",
      }),
    };


    return this.http.get(
      ""+this.apiUrl+"/Bill/GetAllOrderItemAmt?OrderMaster_Id=" +
        parseInt(id) +
        "&Fetch=ADD TO CART",
      httpOptions
    );


    // return this.http.get(
    //   "http://localhost:57597/api/Bill/GetAllOrderItemAmt?OrderMaster_Id=" +
    //     parseInt(id) +
    //     "&Fetch=ADD TO CART",
    //   httpOptions
    // );



  }


  getCartItemsOrderedById(id: any) {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
        key: "x-api-key",
        value: "NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x",
      }),
    };


    return this.http.get(
     ""+this.apiUrl+"/Bill/GetAllOrderItemById?Id=" +
        parseInt(id) ,
      httpOptions
    );


    // return this.http.get(
    //   "http://localhost:57597/api/Bill/GetAllOrderItemById?Id=" +
    //     parseInt(id) ,
    //   httpOptions
    // );


  }

 // GetAllOrderItemByInvoiceNO

 getAllOrderItemByInvoiceNO(id:string) {
  var httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Headers": "Content-Type",
      "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
      key: "x-api-key",
      value: "NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x",
    }),
  };
  return this.http.get(
  
  ""+this.apiUrl+"/Bill/GetAllOrderItemByInvoiceNO?InvoiceNO="+id,httpOptions

  // "http://localhost:57597/api/Bill/GetAllOrderItemByInvoiceNO?InvoiceNO="+id,httpOptions


  );


}



getAllTrackByOrderId( id : string) {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
        key: "x-api-key",
        value: "NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x",
      }),
    };
    return this.http.get(


      ""+this.apiUrl+"/Courier/GetAllTrackByOrderId?invoiceno=" +
      id ,
      httpOptions

      
      // "http://localhost:57597/api/Courier/GetAllTrackByShipmentId?Id=" +
      //  parseInt(id) ,
      //  httpOptions
      


    );
}


GetAllBillByInvoiceNOStockOut( InvoiceNOs : string) {
  var httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Headers": "Content-Type",
      "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
      key: "x-api-key",
      value: "NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x",
    }),
  };
  return this.http.get(


    ""+this.apiUrl+"/Bill/GetAllBillByInvoiceNOStockOut?InvoiceNO=" +
    InvoiceNOs ,
    httpOptions


    // "http://localhost:57597/api/Bill/GetAllBillByInvoiceNOStockOut?InvoiceNO=" +
    //  InvoiceNOs ,
    //  httpOptions
    


  );
}


  getcancelOrderItem(ivn:string , sms:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
  return this.http.get(""+this.apiUrl+"/Bill/CancelOrderItem?InvoiceNO="+ivn +"&SMS="+sms ,httpOptions);

  //return this.http.get("http://localhost:57597/api/Bill/CancelOrderItem?InvoiceNO="+ivn +"&SMS="+sms ,httpOptions);

  }


  
  SendingSMSOrMailData(  invoicenos:string) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
      
  return this.http.get(""+this.apiUrl+"/Bill/SendingSMSOrMail?InvoiceNo="+invoicenos,httpOptions);
  
 // return this.http.get("https://adminapisnew.hideandskin.in/api/Bill/SendingSMSOrMail?InvoiceNo="+invoicenos,httpOptions);
 

  }


}
